import { render, staticRenderFns } from "./PostMenu.vue?vue&type=template&id=8c49def0&scoped=true&"
import script from "./PostMenu.vue?vue&type=script&lang=js&"
export * from "./PostMenu.vue?vue&type=script&lang=js&"
import style0 from "./PostMenu.vue?vue&type=style&index=0&id=8c49def0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c49def0",
  null
  
)

export default component.exports